import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
    fontSize: 16,
    width: 'auto',
    cursor: 'pointer',
  },
  option: {
    fontSize: 16,
  },
}))

export default useStyles
